import { useQuery } from '@tanstack/react-query';
import { getResourceFolderBySlug } from '../api/resources.member.api';
import { resourcesKeys } from './resources.keys';

/**
 * One resource folder by slug, including its items[].
 *
 * @param slug - the folder URL slug from route params.
 */
export function useResourceFolder(slug: string) {
  return useQuery({
    queryKey: resourcesKeys.folder(slug),
    queryFn: () => getResourceFolderBySlug(slug),
    enabled: slug.length > 0,
  });
}
